import {createSlice} from '@reduxjs/toolkit'
import { userLogin } from '@/store/auth/action';

const initialState = {
  access_token: localStorage.getItem('access_token')
}

const slice = createSlice({
  name: 'authSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(userLogin.fulfilled, (state, action) => ({
        access_token: action.payload.access_token,
        loadingAction: false
      }
    ))
    builder.addCase(userLogin.rejected, (state) => ({
        ...state,
        loadingAction: false
      }
    ))
    builder.addCase(userLogin.pending, (state) => ({
        ...state,
        loadingAction: true
      }
    ))
  }
})

export const authActions = slice.actions

export default slice
